import { formatMoney } from 'accounting';
import classNames from 'classnames';
import { SectionHeadline } from 'components/content';
import { SavingIndicator, SavingIndicatorStatus } from 'components/indicator';
import { computed } from 'mobx';
import { inject, observer } from 'mobx-react';
import * as React from 'react';
import { IAppOnlyStore } from 'stores/AllStores';

// Styles
const s = require('./RepSales.css');
const briefcaseIcon = require('assets/briefcase icon.svg');
const iconDropdownArrow = require('assets/dropdown arrow.svg');

// Props
// tslint:disable-next-line:no-empty-interface
interface IRepSalesProps extends IAppOnlyStore {}

// Component
@inject('store')
@observer
export class RepSales extends React.Component<IRepSalesProps, {}> {
  constructor(props: IRepSalesProps) {
    super(props);
    this.props.store.orderPad.fetchOrderPadInfo();
    this.props.store.orderPadSales.fetchSalesData();
  }

  @computed private get isLoading(): boolean {
    const { orderPad, orderPadSales } = this.props.store;

    return (
      (orderPad.isOrderPadInfoLoading || orderPadSales.isSalesDataLoading) &&
      (orderPad.orderPadUrl === null || orderPadSales.salesData === null)
    );
  }

  @computed private get salesColumns(): Array<{
    label: string;
    amount: number;
  }> {
    const { salesData } = this.props.store.orderPadSales;

    return [
      {
        label: 'Sales today',
        amount: salesData.salesToday,
      },
      {
        label: 'This week',
        amount: salesData.salesThisWeek,
      },
      {
        label: 'This month',
        amount: salesData.salesThisMonth,
      },
      {
        label: 'Collections this month',
        amount: salesData.collectionsThisMonth,
      },
    ];
  }

  public render() {
    return (
      <SectionHeadline
        className={s.container}
        title="Your sales"
        button={
          this.isLoading
            ? undefined
            : {
                onClick: this.handleOpeningOrderPad,
                label: 'Place an order',
                icon: briefcaseIcon,
                showLabel: true,
              }
        }
        placeChildrenInTheMiddle={this.isLoading === false}
      >
        {(this.isLoading && (
          <SavingIndicator
            align="right"
            labels={{
              saving: 'Loading your sales',
            }}
            status={SavingIndicatorStatus.Saving}
          />
        )) || (
          <div className={s.salesTicker}>
            {this.salesColumns.map((col, colIndex) => {
              const isLast = colIndex + 1 >= this.salesColumns.length;

              return (
                <div
                  key={col.label}
                  onClick={
                    isLast ? this.handleOpeningCollectionsModal : undefined
                  }
                  className={classNames(s.salesTickerCol, {
                    [s.last]: isLast,
                  })}
                >
                  <p className={s.salesLabel}>{col.label}</p>
                  <p className={s.salesAmount}>{formatMoney(col.amount)}</p>

                  {isLast && (
                    <img
                      className={s.salesDropdown}
                      src={iconDropdownArrow}
                      width={12}
                      height={6}
                    />
                  )}
                </div>
              );
            })}
          </div>
        )}
      </SectionHeadline>
    );
  }

  private handleOpeningCollectionsModal = () => {
    this.props.store.orderPadSales.toggleCollectionsModal(true);
  };

  private handleOpeningOrderPad = () => {
    window.open(this.props.store.orderPad.orderPadUrl, '_blank');
  };
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/routes/sales/Lead/Sales/RepSales.tsx